/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export interface TzoSettingState {
  IsCustomizeSettingEnabled: boolean;
  IsCompanyLogoAttached: boolean;
  CompanyLogoType: string;
  CompanyLogoSrc: string;
  CompanyLogoFilename: string;
  BrandColorCodeType: string;
  BrandColorCode: string;
  SubDomainName: string;
  SiteUrl: string;
  SiteName: string;
  LoginPageText: string;
}

const initialState: TzoSettingState = {
  IsCustomizeSettingEnabled: false,
  IsCompanyLogoAttached: false,
  CompanyLogoType: '',
  CompanyLogoSrc: '',
  CompanyLogoFilename: '',
  BrandColorCodeType: '',
  BrandColorCode: '',
  SubDomainName: '',
  SiteUrl: '',
  SiteName: '',
  LoginPageText: '',
};

export const settingSlice: any = createSlice({
  name: 'tzo_settings',
  initialState,
  reducers: {
    setIsCustomizeSettingEnabled: (state, action) => {
      state.IsCustomizeSettingEnabled = action.payload;
    },
    setIsCompanyLogoAttached: (state, action) => {
      state.IsCompanyLogoAttached = action.payload;
    },
    setCompanyLogoType: (state, action) => {
      state.CompanyLogoType = action.payload;
    },
    setCompanyLogoSrc: (state, action) => {
      state.CompanyLogoSrc = action.payload;
    },
    setCompanyLogoFilename: (state, action) => {
      state.CompanyLogoFilename = action.payload;
    },
    setBrandColorCodeType: (state, action) => {
      state.BrandColorCodeType = action.payload;
    },
    setBrandColorCode: (state, action) => {
      state.BrandColorCode = action.payload;
    },
    setSubDomainName: (state, action) => {
      state.SubDomainName = action.payload;
    },
    setSiteUrl: (state, action) => {
      state.SiteUrl = action.payload;
    },
    setSiteName: (state, action) => {
      state.SiteName = action.payload;
    },
  },
});

export const {
  setIsCustomizeSettingEnabled,
  setIsCompanyLogoAttached,
  setCompanyLogoType,
  setCompanyLogoSrc,
  setCompanyLogoFilename,
  setBrandColorCodeType,
  setBrandColorCode,
  setSubDomainName,
  setSiteUrl,
  setSiteName,
} = settingSlice.actions;

export const settingReducer = settingSlice.reducer;
